<template lang="pug">
  .message-box(
    v-if="message"
    :class="'message-box_' + type"
  )
    .message-box__icon
      IconMessageBoxAttention(
        :type="type"
      )
    p.message-box__value(
      v-html="message"
    )
</template>

<script>
import IconMessageBoxAttention from '@/components/icons/dashboard/MessageBoxAttention'

export default {
  components: {
    IconMessageBoxAttention
  },

  props: {
    message: {
      type: String,
      default: ''
    },
    // warning, info
    type: {
      type: String,
      default: 'warning'
    }
  }
}
</script>

<style lang="scss" scoped>
.message-box {
  text-align: left;
  position: relative;
  border-radius: 4px;
  background-color: #F7F7F7;
  padding: 8px 12px 8px 36px;

  &_warning {
    .message-box__icon {
      fill: #F87900;
      stroke: #F87900;
    }
  }

  &_info {
    .message-box__icon {
      fill: #0A5CD7;
      stroke: #0A5CD7;
      path {
        fill: #0A5CD7;
        stroke: #0A5CD7;
      }
    }
  }

  &__value {
    margin: 0;
    color: #2D2D2D;
    font-size: 14px;
    line-height: 19px;
  }

  &__icon {
    top: 9.5px;
    left: 13.5px;
    display: flex;
    position: absolute;
  }
}
</style>
